export namespace S25UUID {
    export function quickGUID(): string {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    export function random(): string {
        // crypto not available unless httpS, so for local / gauss just fallback to generateQuickGUID
        if (window.crypto?.randomUUID) {
            return window.crypto.randomUUID();
        }
        return quickGUID();
    }
}
